// extracted by mini-css-extract-plugin
module.exports = {"chromeframe":"ProjectNav_chromeframe__2UWH-","main":"ProjectNav_main__3eZtj","project":"ProjectNav_project__2l9Cw"};